import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { EmailTemplate } from './email-template'
import { emailTemplateActions } from './email-template.actions'
import * as fromEmailTemplate from './email-template.reducer'
import { EmailTemplateService } from './email-template.service'
import { concatMap, map, take, tap } from 'rxjs/operators'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class EmailTemplateEffects extends ResourceEffects<EmailTemplate> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public emailTemplateService: EmailTemplateService
  ) {
    super(
      fromEmailTemplate.FEATURE_NAME,
      emailTemplateService,
      emailTemplateActions,
      actions$
    )
  }

  sendTestById = createEffect(() =>
    this.actions$.pipe(
      ofType(emailTemplateActions.sendTestById),
      concatMap((action) =>
        this.emailTemplateService
          .sendTestById(action.id, action.toEmail)
          .pipe(
            map((response) =>
              emailTemplateActions.setLoading({ isLoading: false })
            )
          )
      )
    )
  )
  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole: any
          this.store
            .select(persistentUserRoleSelectors.selectSelectedUserRole)
            .pipe(take(1))
            .subscribe((user) => {
              userRole = user
            })
          userRole && this.store.dispatch(emailTemplateActions.resetState())
        })
      ),
    { dispatch: false }
  )
}
